module.exports = __webpack_public_path__ + "img/hithamStore.498ca02b.jpeg";